import { render, staticRenderFns } from "./integration-service.vue?vue&type=template&id=253b460c"
import script from "./integration-service.vue?vue&type=script&lang=js"
export * from "./integration-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports